import React, { useEffect, useRef, useState } from 'react';
import goldbar from '../../assets/lingotti/100g - Still life Careisgold-Modifica.webp';
import kinegram from "../../assets/lingotti/Retro_kinegram.webp";
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp'
import Footer from '../../components/Footer';
import AOS from "aos";
import "aos/dist/aos.css";


const ImageFollow = () => {
  const containerRef = useRef(null);
  const [imageLeft, setImageLeft] = useState('10%');
  const transitionDuration = '1s';
  const [section, setSection] = useState('');
  const sectionRef = useRef(section);
  const [width, setWidth] = useState(window.innerWidth);
  const [rotateImage, setRotateImage] = useState(false);
  const [imageChange, setImageChange] = useState(false);
  const imageRef = useRef(null);
  const lastSectionRef = useRef(null);
  const [isStopped, setIsStopped] = useState(false);

  function initAOS() {
    AOS.init({
      disable: window.innerWidth <= 320 && window.innerHeight <= 256
    });
  }

  initAOS();

  window.addEventListener("resize", () => {
    AOS.refreshHard();
  });

  useEffect(() => {
    if (section && section.trim() !== "") {
      sectionRef.current = section;
    }
  }, [section]);

  useEffect(() => {
    let scrollTimeout = null;

    const handleScrollStop = () => {
      if (width <= 1024) return;
      if (!containerRef.current || !lastSectionRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const lastSectionRect = lastSectionRef.current.getBoundingClientRect();

      const insideSections =
        containerRect.top < window.innerHeight && containerRect.bottom > 0;

      const beforeFooter = lastSectionRect.top > 0 && !isStopped;

      if (!insideSections || !beforeFooter) return;

      const sectionElement = document.querySelector(sectionRef.current);
      if (sectionElement) {
        sectionElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    };

    const onScroll = () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(handleScrollStop, 150);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [width, isStopped]);

  // handle window resize state
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const sections = containerRef.current.querySelectorAll('div[id^="section"]');
    // const image = containerRef.current.querySelector('img');
    // image.style.transition = transitionDuration;

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const newPosition = entry.target.id === 'section1' || entry.target.id === 'section3' || entry.target.id === 'section5' || entry.target.id === 'section7' ? '20%' : '80%';
          setSection('#' + entry.target.id);
          setImageLeft(newPosition);
          // if (entry.target.id === 'section5') {
          //   setRotateImage(true);
          //   setTimeout(() => {
          //     setImageChange(true);
          //   }, 250);
          // } else {
          setRotateImage(false);
          setTimeout(() => {
            setImageChange(false);
          }, 250);
          // }

        }
      });
    };



    const observerOptions = {
      root: null,
      threshold: 0.5,
      rootMargin: "0px"
    };
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => {
      observer.observe(section);
    });

    return () => {
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []);

  

  useEffect(() => {
    const handleImageStop = () => {
      if (!containerRef.current || !lastSectionRef.current || width < 768) return;

      const lastSectionRect = lastSectionRef.current.getBoundingClientRect();
      const imageEl = imageRef.current;

      if (!imageEl) return;

      const imageHeight = imageEl.offsetHeight;
      const viewportCenter = window.innerHeight / 2;

      // when the center of the fixed image would go below the last section bottom
      const shouldStop = lastSectionRect.bottom <= viewportCenter + imageHeight / 2;

      setIsStopped(shouldStop);
    };

    window.addEventListener('scroll', handleImageStop);
    window.addEventListener('resize', handleImageStop);

    handleImageStop();

    return () => {
      window.removeEventListener('scroll', handleImageStop);
      window.removeEventListener('resize', handleImageStop);
    };
  }, [width]);

  return (
    <>
      <Helmet>
        <title>Lingotti Oro: Massima Sicurezza | Careisgold</title>
        <meta name="description" content="Scopri i lingotti d'oro proposti da Careisgold. Tecnologia avanzata per la massima sicurezza e autenticità del tuo investimento in oro" />
        <meta name="keywords" content="lingotti oro, sicurezza oro, autenticità oro, Careisgold" />
        <meta property="og:title" content="Lingotti Oro: Massima Sicurezza | Careisgold" />
        <meta property="og:description" content="Scopri i lingotti d'oro proposti da Careisgold. Tecnologia avanzata per la massima sicurezza e autenticità del tuo investimento in oro." />
        <meta property="og:image" content={goldbar} />
        <meta property="og:url" content="https://www.careisgold.it/lingotti/" />
        <meta property="og:type" content="page" />
        <link rel="canonical" href="https://www.careisgold.it/lingotti/" />
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Lingotti Oro: Massima Sicurezza | Careisgold",
          "url": "https://www.careisgold.it/lingotti/",
          "description": "Scopri i lingotti d'oro proposti da Careisgold. Tecnologia avanzata per la massima sicurezza e autenticità del tuo investimento in oro.",
          "inLanguage": "it",
          "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": "https://www.careisgold.it${goldbar}"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Careisgold SpA",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.careisgold.it${logo}"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Via Monte Baldo 14/D",
              "addressLocality": "Villafranca di Verona",
              "addressRegion": "Veneto",
              "postalCode": "37069",
              "addressCountry": "IT"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+39 045 8213155",
              "contactType": "Customer Service"
            },
            "sameAs": [
              "https://www.facebook.com/careisgoldspa",
              "https://www.instagram.com/careisgoldspa",
              "https://www.linkedin.com/company/careisgold-spa"
            ]
          }
        }
      `}
        </script>
      </Helmet>

      <div ref={containerRef} className='z-40 relative'>
        <img
          ref={imageRef}
          src={goldbar}
          style={{
            width: '20%',
            position: isStopped ? 'absolute' : 'fixed',
            left: imageLeft,
            top: isStopped ? 'auto' : '50%',
            bottom: isStopped ? '0' : 'auto',
            transform: isStopped
              ? `translateX(-50%) ${rotateImage ? 'rotateY(180deg)' : ''}`
              : `translate(-50%, -50%) ${rotateImage ? 'rotateY(180deg)' : ''}`,
            transition: `left ${transitionDuration} ease, transform 1s`,
            zIndex: 20,
            pointerEvents: 'none',
          }}
          className='hidden md:block'
          alt='lingotto argor herause'
        />
        {width < 768 && width > 320 ? (
          <div className='fade-lingotto'>
            <img
              src={goldbar}
              style={{
                objectFit: 'contain',
                objectPosition: 'top',
                width: `${width < 480 ? '50%' : '30%'}`
              }}
              alt='lingotto argor herause'
            />
          </div>) : width <= 320 ? (
            <div className='fade-lingotto-mini'>
              <img
                  src={goldbar}
                  style={{
                objectFit: 'contain',
                objectPosition: 'top',
                // width: `${width < 480 ? '50%' : '30%'}`
              }}
                  className='h-[50vh]'
                  alt='lingotto argor herause'
              />
            </div>
            ) : null}
        <div id="section1" className='bg-black md:h-dvh text-slate-50 flex items-center justify-end'>
          <div className={`w-full md:w-2/3 lg:w-2/3 text-left lg:pe-56 lg:pl-0 p-4 mt-[25rem] sm:mt-[30rem] md:mt-[12rem] lg:mt-0`}>
            <h4 className={`lg:text-6xl text-slate-50 font-semibold `} data-aos={width > 768 ? "fade-up" : "fade-in"} data-aos-duration="3000">
              Ogni lingotto è un mattone che costruisce il tuo futuro</h4>
            <div className={`text-md lg:text-lg mt-4 mb-10 text-slate-50`} data-aos="fade-in" data-aos-duration="3000">
              <div className=' pr-4'>
                Careisgold offre solo lingotti che rispecchiano la massima qualità disponibile sul mercato. Ogni prodotto
                segue rigorosi standard di qualità e sicurezza, con <h1 className='inline'>lingotti di purezza 999,9‰ Good Delivery.</h1> I lingotti sono garantiti dai più avanzati sistemi anti-contraffazione e provengono da raffinerie certificate dalla London Bullion Market Association.
              </div>
            </div>
          </div>
        </div>
        <div id="section2" className='bg-black md:h-dvh text-slate-50 flex items-center justify-start'>
          <div className="w-full md:w-2/3 lg:w-2/3 text-left lg:pe-56 lg:pl-28 p-4 lg:mt-0">
            <h4 className={` lg:text-6xl text-slate-50 font-semibold`} data-aos={width > 768 ? "fade-up" : "fade-in"} data-aos-duration="3000">
              Careisgold è impegnata nel fornire solo il meglio ai propri clienti</h4>
            <div className={`text-md lg:text-lg mt-4 mb-10 text-slate-50`} data-aos="fade-in" data-aos-duration="3000">
              <p className=''>
                Per questo, collaboriamo con partner d’eccellenza per la produzione dei lingotti d’oro e per i servizi
                destinati ai nostri clienti. Fiducia e sicurezza sono i capisaldi che guidano l’azienda nel proporre soluzioni
                che soddisfino i più alti standard di qualità.
              </p>
            </div>
          </div>
        </div>
        <div id="section3" className='bg-black md:h-dvh text-slate-50 flex items-center justify-end'>
          <div className="w-full md:w-2/3 lg:w-2/3 text-left lg:pe-56 p-4 lg:mt-0">
            <h4 className={`lg:text-6xl text-slate-50 font-semibold`} data-aos={width > 768 ? "fade-up" : "fade-in"} data-aos-duration="3000">I migliori lingotti d’oro puro certificati</h4>
            <div className={`text-md lg:text-lg mt-4 mb-10 text-slate-50`} data-aos="fade-in" data-aos-duration="3000">
              <p className=''>
                Careisgold ha scelto <b> Argor-Heraeus Italia SpA </b> come partner per offrire ai propri clienti i migliori lingotti
                d’oro puro certificati. Rinomata a livello globale per la sua eccellenza nel settore della raffinazione,
                Argor-Heraeus rappresenta l’élite nella produzione di lingotti d’oro puro fisico ed è garanzia di
                tracciabilità e liquidabilità.
              </p>
            </div>
          </div>
        </div>
        <div id="section4" ref={lastSectionRef} className='bg-black md:h-dvh text-slate-50 flex items-center justify-start'>
          <div className="w-full md:w-2/3 lg:w-2/3 text-left lg:pe-56 lg:pl-28 p-4 lg:mt-0">
            <h4 className={` lg:text-6xl text-slate-50 font-semibold`} data-aos={width > 768 ? "fade-up" : "fade-in"} data-aos-duration="3000">Filiera etica</h4>
            <div className={`text-md lg:text-lg mt-4 mb-10 text-slate-50`} data-aos="fade-in" data-aos-duration="3000">
              <p className=''>
                L’Oro di Careisgold viene estratto con tecniche non invasive, senza l’utilizzo di agenti chimici inquinanti
                o esplosivi e con il massimo riguardo per l’ambiente. Vengono rispettate tutte le normative relative alla
                sicurezza e al lavoro, per tutelare coloro che operano in condizioni rischiose ed evitare il fenomeno
                dello sfruttamento minorile.
              </p>
            </div>
          </div>
        </div>
        {/* <div id="section5" className='bg-black md:h-dvh text-slate-50 flex items-center justify-end'>
              <div className="w-full lg:w-2/3 text-left lg:pe-56 p-4 lg:mt-0">
              <h4 className={`lg:text-6xl text-slate-50 font-semibold`} data-aos={width > 800 ? "fade-up" : "fade-in"} data-aos-duration="3000">La sicurezza è tuo diritto e una nostra responsabilità</h4>
                <div className={`text-md lg:text-lg mt-4 mb-10 text-slate-50`} data-aos="fade-in" data-aos-duration="3000">
                      <p className=''>
                        I lingotti fino al peso di 100gr sono dotati di tecnologia <b>Kinegram®.</b> Tale sistema anti-contraffazione,
                        utilizzata anche per banconote e passaporti, garantisce la massima sicurezza e trasparenza contro frodi
                        e falsificazioni.
                      </p>
                  </div>
              </div>
            </div> */}
      </div>
    </>

  );
}

export default ImageFollow;
